export default function extractUniqueTags(data) {
  const tagsSet = new Set();
  data.forEach((entry) => {
    const tags = entry.tags;
    if (tags) {
      const individualTags = tags.split(",").map((tag) => tag.trim());
      individualTags.forEach((tag) => tagsSet.add(tag));
    }
  });
  return Array.from(tagsSet);
}
